import { A } from "@solidjs/router";
import { createSignal, Show } from "solid-js";

import type { FirmSummary } from "../api";

function fmtMcapB(v: number | null | undefined): string | null {
  if (v == null) return null;
  if (v >= 1e12) return `$${(v / 1e12).toFixed(2)}T`;
  if (v >= 1e9) return `$${(v / 1e9).toFixed(0)}B`;
  if (v >= 1e6) return `$${(v / 1e6).toFixed(0)}M`;
  return `$${v.toLocaleString()}`;
}

function CardLogo(props: { slug: string; hasIcon: boolean; hasLogo: boolean }) {
  const [errored, setErrored] = createSignal(false);
  const kind = props.hasIcon ? "icon" : props.hasLogo ? "logo" : null;
  if (!kind) return null;
  return (
    <Show when={!errored()}>
      <img
        class="card-logo"
        src={`/api/firms/${encodeURIComponent(props.slug)}/branding/${kind}`}
        alt=""
        loading="lazy"
        onError={() => setErrored(true)}
      />
    </Show>
  );
}

export default function FirmCard(props: { firm: FirmSummary }) {
  const f = props.firm;
  const mcap = fmtMcapB(f.market_cap);
  return (
    <A class="card" href={`/firm/${f.slug}`}>
      <div class="card-head">
        <span class="rank">#{f.f500_rank ?? "?"}</span>
        <CardLogo
          slug={f.slug}
          hasIcon={!!f.branding?.icon_path}
          hasLogo={!!f.branding?.logo_path}
        />
        <span class="firm-name">{f.name}</span>
        <Show keyed when={f.ticker}>
          {(t) => <span class="ticker-chip ticker-chip-sm">{t}</span>}
        </Show>
      </div>
      <div class="card-meta">
        <span>{f.sector}</span>
        <span>${f.revenue_b_usd_fy2025}B rev</span>
        <Show when={mcap}>
          <span>{mcap} mkt</span>
        </Show>
        <span>{f.hq}</span>
      </div>
      <p class="pitch">{f.pitch}</p>
    </A>
  );
}
